
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { 
  Store, 
  Users, 
  Phone,
  MessageSquare, 
  Megaphone, 
  ThumbsUp, 
  CreditCard,
  Globe,
  BarChart3
} from "lucide-react";
import { Shop } from "@/components/dashboard/shops/types";
import { cn } from "@/lib/utils";

interface ShopSettingsSidebarProps {
  shop: Shop;
  activeMenu: string;
  setActiveMenu: (menu: string) => void;
}

interface MenuOption {
  id: string;
  name: string;
  icon: React.ReactNode;
}

export const ShopSettingsSidebar: React.FC<ShopSettingsSidebarProps> = ({
  shop,
  activeMenu,
  setActiveMenu,
}) => {
  const menuOptions: MenuOption[] = [
    {
      id: "profile",
      name: "Profil",
      icon: <Store className="h-5 w-5" />,
    },
    {
      id: "forms",
      name: "Formulaires",
      icon: <Users className="h-5 w-5" />,
    },
    {
      id: "social-media",
      name: "Réseaux Sociaux",
      icon: <MessageSquare className="h-5 w-5" />,
    },
    {
      id: "announcement-bar",
      name: "Bandeau d'annonce",
      icon: <Megaphone className="h-5 w-5" />,
    },
    {
      id: "thank-you-page",
      name: "Page de remerciement",
      icon: <ThumbsUp className="h-5 w-5" />,
    },
    {
      id: "payment",
      name: "Méthodes de paiement",
      icon: <CreditCard className="h-5 w-5" />,
    },
    {
      id: "domains",
      name: "Domaines personnalisés",
      icon: <Globe className="h-5 w-5" />,
    },
    {
      id: "tracking",
      name: "Tracking & Analytics",
      icon: <BarChart3 className="h-5 w-5" />,
    },
  ];

  return (
    <Card className="md:col-span-1 shadow-md border-0 dark:border dark:border-gray-800">
      <CardContent className="p-0">
        <ul className="menu-options divide-y divide-gray-100 dark:divide-gray-800">
          {menuOptions.map((option) => (
            <li key={option.id}>
              <button
                onClick={() => setActiveMenu(option.id)}
                className={cn(
                  "flex items-center gap-3 px-6 py-4 w-full text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors",
                  activeMenu === option.id
                    ? "bg-gray-50 dark:bg-gray-800/50 text-custom-primary dark:text-custom-secondaryLight font-medium"
                    : "text-gray-700 dark:text-gray-300"
                )}
              >
                {React.cloneElement(option.icon as React.ReactElement, {
                  className: cn(
                    (option.icon as React.ReactElement).props.className,
                    activeMenu === option.id
                      ? "text-custom-primary dark:text-custom-secondaryLight"
                      : "text-gray-500 dark:text-gray-400"
                  ),
                })}
                <span>{option.name}</span>
              </button>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
